module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page no-top-nav social-verify-page"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": "",
      "flex-column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md8": ""
    }
  }, [(_vm.token == 'being') ? [_c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Check your email & confirm your account")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n                  If you don't see the email in your main inbox"), _c('br'), _vm._v("check your\n                  other folders like 'promotions'\n                ")]), _vm._v(" "), (_vm.user_type != 0) ? _c('div', {
    staticClass: "__artistBrand-note"
  }, [_c('h5', [_vm._v("After you confirm your artist / brand account:")]), _vm._v(" "), _c('ul', {
    staticClass: "allChildrenCenter flex-column"
  }, [_c('li', [_vm._v("\n                      Please allow at least 72 hours for staff to verify your account\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                      If your account hasn’t been verified within 72 hours send us a DM on Instagram to "), _c('a', {
    attrs: {
      "href": "https://instagram.com/yousoundapp",
      "target": "_blank"
    }
  }, [_vm._v("@yousoundapp")]), _vm._v(" from the social media URL you signed up with\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "px-3 mt-4",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendConfirmEmail($event)
      }
    }
  }, [_vm._v("\n                  Resend email\n                ")])], 1)], 1)])] : [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "100vh"
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "30px"
    }
  }, [_vm._v("\n                    Email confirmed!\n                  ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("Your account has been activated")])], 1)])]), _vm._v(" "), _c('div', [(_vm.isPageReady) ? _c('v-btn', {
    staticClass: "px-3 mt-4 login-button",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": "",
      "to": "/login"
    }
  }, [_vm._v("\n                Login to web app\n              ")]) : _vm._e()], 1)])]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6120eda1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/confirmation.vue
// module id = 1745
// module chunks = 180